<template>
  <div class="first-box">
    <div>
      <img src="@/assets/peerfintechimg/FqhDTxW7Cl5kDogayZ5EkQB5UAuJ.png" alt="" width="150" height="150">
    </div>
<!--    https://images.peerfintech.cn/FqhDTxW7Cl5kDogayZ5EkQB5UAuJ-->
<!--    <div class="title">湾区认证</div>-->
    <img src="@/assets/peerfintechimg/FjjuElx_CExU-OkauPUnatCQ1PRM.png" alt="" width="250">
    <!--    "https://images.peerfintech.cn/FjjuElx_CExU-OkauPUnatCQ1PRM"-->
    <div class="title-eng">GREATER BAY AREA CERTIFICATION</div>
    <div class="text">——湾区品质&nbsp;&nbsp;&nbsp;&nbsp;服务全球——</div>
  </div>
</template>

<script>
export default {
  name: 'FrontCover',
  components: {},
  data() {
    return {}
  },
  methods: {
    initData() {
    },
    loadData() {
    }
  },
}
</script>

<style lang="less" scoped>
.first-box {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    margin-top: 1rem;
    font-size: 3rem;
    font-weight: 600;
    color: white;
  }

  .title-eng {
    margin: 1rem 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    text-align: center;
  }

  .text {
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    text-align: center;
    white-space: nowrap;
  }
}
</style>
